import { IState } from 'core/types';

export const getIsInitAppLoading = ({ app }: IState) => app.isInitAppLoading;
export const getAreasAlias = ({ app }: IState) => app.areasAlias;
export const getServerError = ({ app }: IState) => app.serverError;
export const getUserData = ({ app }: IState) => app.userInfo;
export const getVisitorStatus = ({ app }: IState) => app.isDoctor;
